import React, { ReactElement } from 'react'
import { IColorTheme } from '../../../types/itemTypes'
import ItemGridSelect from './ItemGridSelect'
import { ICategoryResponse } from '../../../types/organisation'

interface ISubCategorySelectProps {
  subCategories: ICategoryResponse[]
  selectedSubCategoryId: number | undefined
  setSelectedSubCategoryId: (subCategoryId: number | undefined) => void
  colorTheme?: Partial<IColorTheme>
}

export default function SubCategorySelect(
  props: ISubCategorySelectProps,
): ReactElement {
  const {
    subCategories,
    selectedSubCategoryId,
    setSelectedSubCategoryId,
    colorTheme,
  } = props

  const options = subCategories.map((category) => ({
    value: category.id,
    label: category.title,
  }))

  const selectedOption = selectedSubCategoryId
    ? options.find((option) => option.value === selectedSubCategoryId)
    : undefined

  return (
    <ItemGridSelect<number>
      placeholder="Show all"
      selected={selectedOption}
      options={options}
      onSelect={(option): void => {
        if (option) {
          setSelectedSubCategoryId(option.value)
        } else {
          setSelectedSubCategoryId(undefined)
        }
      }}
      colorTheme={colorTheme}
    />
  )
}
